import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionLabel, MaskedHeading, Reveal } from "@/components/site/Motion";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Events = () => {
  const { t } = useLang();
  return (
    <section id="events" className="py-24 md:py-36 px-6 md:px-12 bg-surface/30 border-y border-white/10">
      <div className="max-w-[1600px] mx-auto">
        <div className="mb-14">
          <SectionLabel>{t.events.overline}</SectionLabel>
          <h2 className="font-heading text-4xl md:text-6xl text-white tracking-tight">
            <MaskedHeading text={t.events.title} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-4 font-body text-white/55 max-w-lg">{t.events.desc}</p>
          </Reveal>
        </div>

        <div className="space-y-px">
          {t.events.list.map((ev, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <button
                data-testid={`event-${i}`}
                onClick={() => scrollTo("reserve")}
                className="group w-full text-left grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 items-center py-8 border-t border-white/10 hover:border-brand/40 transition-colors"
              >
                <span className="md:col-span-2 font-display text-brand text-sm tracking-widest uppercase">
                  {ev.day}
                </span>
                <span className="md:col-span-5 font-heading text-2xl md:text-4xl text-white group-hover:translate-x-2 transition-transform duration-300">
                  {ev.title}
                </span>
                <span className="md:col-span-2 font-body text-white/60">{ev.time}</span>
                <span className="md:col-span-2 font-body text-xs tracking-widest uppercase text-white/50">
                  {ev.tag}
                </span>
                <span className="md:col-span-1 flex md:justify-end">
                  <span className="inline-flex items-center gap-1 text-white/60 group-hover:text-brand transition-colors">
                    <span className="font-body text-sm md:hidden">{t.events.book}</span>
                    <ArrowUpRight size={22} />
                  </span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
